import { ChevronLeft, ChevronRight } from 'lucide-react';

const ModernTravelControls = ({ totalCount, activeIndex, onPrev, onNext, onSelectIndex }) => {
  return (
    <div className="flex items-center justify-center pt-2">
      <div className="flex items-center gap-4 bg-white px-5 py-2.5 rounded-full border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
        <button
          onClick={onPrev}
          className="p-1 text-gray-400 hover:text-[#067978] transition-colors cursor-pointer"
          aria-label="Previous slide"
        >
          <ChevronLeft size={22} strokeWidth={3} />
        </button>

        {/* Dots */}
        <div className="flex gap-2.5">
          {Array.from({ length: totalCount }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => onSelectIndex(idx)}
              className={`h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                activeIndex === idx ? 'w-8 bg-[#067978]' : 'w-2.5 bg-gray-200 hover:bg-gray-300'
              }`}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>

        <button
          onClick={onNext}
          className="p-1 text-gray-400 hover:text-[#067978] transition-colors cursor-pointer"
          aria-label="Next slide"
        >
          <ChevronRight size={22} strokeWidth={3} />
        </button>
      </div>
    </div>
  );
};

export default ModernTravelControls;
